import "./tabView.scss";

import { map } from "lodash";
import PropTypes from "prop-types";
import React, { Fragment, PureComponent } from "react";

import { PropTypeShapes } from "../../types";
import TabBar from "./TabBar";

export default class TabView extends PureComponent {
  constructor(props, context) {
    super(props, context);
  }

  renderTabBar() {
    return (
      <div className="tabView">
        <TabBar
          tabs={this.props.tabs}
          showLabels={this.props.showLabels}
          activeTab={this.props.activeTab}
          onClick={this.props.onTabChange}
          pulsateIconId={this.props.pulsateIconId}
        />
        <div className="tabViewScrollableContainer">{this.props.tabs[this.props.activeTab].view}</div>
      </div>
    );
  }

  renderFlattened() {
    return (
      <Fragment>
        {map(this.props.tabs, (t, i) => (
          <Fragment key={i}>{t.view}</Fragment>
        ))}
      </Fragment>
    );
  }

  render() {
    return this.props.flatten ? this.renderFlattened() : this.renderTabBar();
  }
}

TabView.propTypes = {
  tabs: PropTypeShapes.inspectorTabArray.isRequired,
  flatten: PropTypes.bool,
  showLabels: PropTypes.bool,
  activeTab: PropTypes.number.isRequired,
  onTabChange: PropTypes.func.isRequired,
  pulsateIconId: PropTypes.string
};
